import { Group } from './../../../../shared/shared-emails/model/group';
import { MappedFilter } from './../../../../modules/shared/models/dynamic-table/dynamic-table-column.model';
import { LocalDatePipe } from './../../../../modules/shared/pipes/local-date.pipe';
import { FormControlList, FormControlListIds } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { AppMainService } from './../../../../app-main.service';
import { ColumnDefinition, DynamicTableGroupData } from './../../../../modules/shared/models/dynamic-table/dynamic-table-data.model';
import { DynamicTableService } from './../../../../modules/shared/services/dynamic-table/dynamic-table.service';
import { Fields, SectionN } from './../../../../modules/shared/models/column-settings.model';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil, map } from 'rxjs';
import { WorkbookDynamicChartsM } from '../../models/workbook-dynamic-chart.models';
import { Guid } from "guid-typescript";
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
// import HighchartsGantt from 'highcharts/modules/gantt';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import * as HighchartsG from 'highcharts/highcharts-gantt';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
HighchartsMore(Highcharts);
// HighchartsGantt(Highcharts);
HighchartsAccessibility(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsAccessibility(HighchartsG);
HighchartsExporting(HighchartsG);
HighchartsExportData(HighchartsG);

@Component({
    selector: 'app-workbook-dynamic-bar-chart',
    templateUrl: './workbook-dynamic-bar-chart.component.html',
    styleUrl: './workbook-dynamic-bar-chart.component.scss',
    providers: [LocalDatePipe]
})
export class WorkbookDynamicBarChartComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() workbookId: string = "";
    @Input() isChartDataLoading: boolean = false;
    @Input() formDashboard: boolean = false;
    @Input() dynamicChart: WorkbookDynamicChartsM = null;
    @Input() allListColumns: SectionN[] = [];
    @Input() filterInColumns: MappedFilter[];
    @Output() onDataLoading: EventEmitter<boolean> = new EventEmitter();
    @Output() onDialogClosed = new EventEmitter();

    uniqueId: string = Guid.create().toString();
    selectedGroupBy: Fields = null;
    selectedColumns: Fields[] = null;
    aggreegatedColumns: any[] = null;

    dynamicTableData: DynamicTableGroupData = null;
    ganttChart: any = null;
    barChart: any = null;
    lineChart: any = null;
    pieChart: any = null;

    // Derived properties for easier access
    get xAxisColumns() {
        return this.dynamicChart?.columns?.filter(c => c.isReference === 'xaxis') || [];
    }

    get yAxisColumns() {
        return this.dynamicChart?.columns?.filter(c => c.isReference === 'yaxis') || [];
    }

    constructor(
        private readonly appMainService: AppMainService,
        private dynamicTableService: DynamicTableService,
        private localDatePipe: LocalDatePipe
    ) { }

    ngOnInit(): void {
        if (this.formDashboard && this.dynamicChart) {
            this.getWorkbookColumns();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allListColumns'] && changes['allListColumns'].currentValue) {
            this.allListColumns = changes['allListColumns'].currentValue;
        }

        if (changes['dynamicChart'] && changes['dynamicChart'].currentValue) {
            this.dynamicChart = changes['dynamicChart'].currentValue;

            if (this.formDashboard) {
                this.getWorkbookColumns();
            } else {
                this.getSelectedColumns();
                !this.isChartDataLoading && this.getGroupByDynamicTable();
            }
        }

        if (changes['filterInColumns'] && changes['filterInColumns'].currentValue) {
            this.filterInColumns = changes['filterInColumns'].currentValue;
            !this.isChartDataLoading && this.getGroupByDynamicTable();
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    getWorkbookColumns() {
        this.appMainService.isShowSpinner('getDynamicTableColumn');
        this.dynamicTableService.getDynamicTableColumn(this.dynamicChart.workbookGuId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response: ColumnDefinition[]) => {
                this.appMainService.isHideSpinner('getDynamicTableColumn');
                this.allListColumns = this.mapWorkbookColumnDefinitions(response || []);
                this.getSelectedColumns();
                this.getGroupByDynamicTable();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getDynamicTableColumn');
            }
        })
    }

    mapWorkbookColumnDefinitions(columnDefinitions: ColumnDefinition[]): any[] {
        return [
            {
                customFields: [],
                fields: columnDefinitions
                    .sort((a, b) => (a.displayOrder) - (b.displayOrder))
                    .map((col) => ({
                        id: col.id,
                        intId: col.intId,
                        name: col.name,
                        labelName: col.name,
                        field: col.name,
                        columnName: col.name,
                        dragable: true,
                        operators: col.searchOperators,
                        formControlId: col.formControlId,
                        formControl: col.formControlName,
                        fieldDataType: col.dataType,
                        enabledInForm: true,
                        enabled: col.enable,
                        isDateWithTime: false,
                        displayOrder: col?.displayOrder || col?.order,
                        readOnly: false,
                        childFields: [],
                        ischecked: true,
                        custom: true,
                        isRequired: false,
                        isDisabled: false,

                    })),
                id: 1,
                name: 'Workbook columns',
                systemGenerated: true,
            },
        ];
    }

    //#region load apis
    getSelectedColumns() {
        this.selectedColumns = [];
        this.aggreegatedColumns = [];
        this.selectedGroupBy = null;

        if(['barChart', 'lineChart', 'pieChart'].includes(this.dynamicChart.type)) {
            const xcolumn = this.dynamicChart.columns.find(x => x.isReference == 'xaxis');
            this.selectedGroupBy = this.allListColumns[0].fields.find(field => field.intId == xcolumn.columnId);
        }else if(this.dynamicChart.type == 'ganttChart') {
            const xcolumn = this.dynamicChart.columns.find(x => x.isReference == 'namefield');
            this.selectedGroupBy = this.allListColumns[0].fields.find(field => field.intId == xcolumn.columnId);
        }

        this.dynamicChart.columns.map(column => {
            const field: any = this.allListColumns[0].fields.find(field => field.intId == column.columnId);
            column.dataList = [];
            column.columnNameId = field?.id || null;
            column.name = field?.name || null;
            column.formControl = field?.formControl || null;
            this.selectedColumns.push(field);
            switch (this.dynamicChart.type) {
                case 'barChart':
                case 'lineChart':
                case 'pieChart':
                    if (column.isReference === 'yaxis') {
                        this.aggreegatedColumns.push({...field, operation: column.operation});
                    }
                    break;
            }
        });
    }

    getGroupByDynamicTable() {
        this.updateLoadingStatus(true);
        const groupByQuery: any = this.buildGroupByQuery();
        this.appMainService.isShowSpinner('getGroupByDynamicTable');
        this.dynamicTableService.getGroupByDynamicTable(groupByQuery).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response: any) => {
                this.updateLoadingStatus(false);
                this.appMainService.isHideSpinner('getGroupByDynamicTable');
                this.dynamicTableData = response;
                this.generateCharts();
            },
            error: (error) => {
                this.updateLoadingStatus(false);
                this.dynamicTableData = null;
                this.generateCharts();
                this.appMainService.isHideSpinner('getGroupByDynamicTable');
            }
        })
    }

    updateLoadingStatus(isLoading: boolean) {
        this.isChartDataLoading = isLoading;
        this.onDataLoading.emit(isLoading);
    }

    generateCharts() {
        this.setChartValues();
        switch (this.dynamicChart.type) {
            case 'barChart':
                this.generateBarChart();
                break;
            case 'lineChart':
                this.generateChartLine();
                break;
            case 'pieChart':
                this.generatePieChart();
                break;
            case 'ganttChart':
                this.generateGanttChart();
                break;
        }
    }

    buildGroupByQuery() {
        let selectableColumns = this.getEnabledColumnNames(this.selectedColumns);
        if (this.selectedGroupBy) {
            selectableColumns = [...selectableColumns, { name: this.selectedGroupBy.columnName }];
        }

        if (this.filterInColumns?.length > 0) {
            selectableColumns = [...selectableColumns, ...this.filterInColumns.map((filter: MappedFilter) => ({ name: filter.name }))];
        }

        // Remove duplicates from selectableColumns
        selectableColumns = selectableColumns.filter((column, index, self) =>
            index === self.findIndex((c) => c.name === column.name)
        );

        const aggregatedBy = this.getAggregatedColumns(this.aggreegatedColumns);
        const filterQuery = {
            aggregatedBy: aggregatedBy?.length ? aggregatedBy : null,
            globalSearchValue: '',
            tableId: this.dynamicChart.workbookGuId,
            pageNumber: 1,
            pageSize: 0,
            selectableColumns: selectableColumns,
            formControlName: this.selectedGroupBy?.formControl,
            rootPageSize: 0,
            rootPageNumber: 1,
            ...(this.filterInColumns ? { filterInColumns: this.filterInColumns } : {}),
            ...(this.selectedGroupBy ? { groupByColumn: { name: this.selectedGroupBy?.name, dataType: this.selectedGroupBy?.fieldDataType } } : {})
        };

        return filterQuery;
    }

    getAggregatedColumns(columns: any[]) {
        if (!columns || !this.dynamicChart.operation || ['ganttChart'].includes(this.dynamicChart.type)) return [];

        return columns.map(col => ({
            columnName: col?.columnName,
            dataType: 'Decimal',
            aggregationType: col.operation||'sum'
        }));
    }

    getEnabledColumnNames(columns: Fields[]): { name: string }[] {
        return columns.map(col => ({ name: col?.columnName }));
    }

    setChartValues() {
        if (!this.dynamicTableData?.result?.list?.length) return;

        this.dynamicChart.columns.map(column => {
            column.dataList = [];

            if (this.dynamicChart.operation && !['ganttChart'].includes(this.dynamicChart.type)) {
                if (column.name == this.selectedGroupBy.columnName) {
                    this.dynamicTableData.result.list.map((groupRow: any) => {
                        let value = groupRow.GroupValue;

                        switch (column.formControl) {
                            case FormControlList.DatePicker:
                            case FormControlList.DateTimePicker:
                                value = value ? this.localDatePipe.transform(value, 'MM-DD-YYYY') : value;
                                break;
                            default:
                                value = value ? value : '';
                        }

                        column.dataList.push(value);
                    });
                } else {
                    this.dynamicTableData.result.list.map((groupRow: any) => {
                        let value = groupRow.AggregatedValues.find((x: any) => x.columnName == column.name)?.value || 0;
                        column.dataList.push(Number(value));
                    });
                }
            } else {
                if (column.name == this.selectedGroupBy.columnName) {
                    this.dynamicTableData.result.list.map((groupRow: any) => {
                        let value = groupRow.GroupValue;

                        switch (column.formControl) {
                            case FormControlList.DatePicker:
                            case FormControlList.DateTimePicker:
                                value = value ? this.localDatePipe.transform(value, 'MM-DD-YYYY') : value;
                                break;
                            default:
                                value = value ? value : '';
                        }

                        groupRow.Data.map((row: any) => {
                            column.dataList.push(value);
                        });
                    });
                } else {
                    this.dynamicTableData.result.list.map((groupRow: any) => {
                        const mappedRows = this.mapRows(groupRow.Data);
                        mappedRows.map((row: any) => {
                            if (this.dynamicChart.type == 'ganttChart') {
                                let value = row.rowData[column.columnNameId]?.value || null;
                                switch (column.formControl) {
                                    case FormControlList.DatePicker:
                                    case FormControlList.DateTimePicker:
                                        value = value ? this.localDatePipe.transform(value, 'YYYY-MM-DD h:mm a') : value;
                                        break;
                                    default:
                                        value = value ? value : '';
                                }

                                column.dataList.push(value);
                            } else {
                                let value = row.rowData[column.columnNameId]?.value || 0;
                                column.dataList.push(Number(value));
                            }
                        });
                    });
                }
            }
        });
    }

    mapRows(rowList: any[]): any[] {
        return rowList.map(row => {
            const rowData = {};
            row.Cells.forEach(cell => {
                rowData[cell.ColumnId] = {
                    value: cell.Value,
                    color: cell.Color,
                    textColor: cell.TextColor
                };
            });
            return {
                RowNumber: row.RowNumber,
                rowData: rowData,
                readStatus: row.ReadStatus,
                noOfComments: row.NoOfComments,
                noOfUnreadComments: row.NoOfUnreadComments,
                noOfDocument: row.NoOfDocument,
                noOfUpcomingReminder: row.NoOfUpcomingReminder,
            };
        });
    }

    generateBarChart() {
        const categories: string[] = this.xAxisColumns.find(x => x.name == this.selectedGroupBy.columnName)?.dataList || [];
        const series = this.yAxisColumns.map(yField => {
            const data: number[] = yField.dataList || [];

            return {
                name: yField.name || yField.columnNameId,
                type: 'column',
                data
            };
        });

        if (this.barChart) { this.barChart.destroy(); }

        this.barChart = Highcharts.chart(`chart-column-${this.uniqueId}` as any, {
            chart: {
                type: 'column',
            },
            title: {
                text: this.dynamicChart.title,
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: true,
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Values',
                },
            },
            xAxis: {
                categories,
                title: {
                    text: this.xAxisColumns[0]?.name,
                },
            },
            tooltip: {
                shared: true,
                useHTML: true,
            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                    }
                }
            },
            series
        } as any);
    }

    generatePieChart(): void {
        const yField = this.yAxisColumns[0];
        const data: any[] = [];
        const categories: string[] = this.xAxisColumns.find(x => x.name == this.selectedGroupBy.columnName)?.dataList || [];
        const values: number[] = yField?.dataList || [];
        categories.map((label: string, i) => {
            data.push({
                name: label,
                y: Number(values?.[i] || 0),
            });
        })


        if (this.pieChart) {
            this.pieChart.destroy();
        }

        this.pieChart = Highcharts.chart(`chart-pie-${this.uniqueId}`, {
            chart: {
                type: 'pie',
            },
            title: {
                text: this.dynamicChart.title,
            },
            credits: {
                enabled: false,
            },
            tooltip: {
                headerFormat: `<span style="font-size: 14px;">{point.key}</span><br>`,
                pointFormat: '<span style="font-size: 13px;">Amount: <b>{point.y}</b></span>',
                useHTML: true,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}: {point.percentage:.1f} %',
                    }
                }
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                    }
                }
            },
            series: [{
                name: yField?.name || yField?.columnNameId || 'Value',
                innerSize: '50%', // for donut style, remove if you want a full pie
                data,
            }],
        } as any);
    }

    generateChartLine(): void {
        const categories: string[] = this.xAxisColumns.find(x => x.name == this.selectedGroupBy.columnName)?.dataList || [];
        const series = this.yAxisColumns.map(yField => {
            const data: number[] = yField.dataList || [];

            return {
                name: yField.name || yField.columnNameId,
                type: 'line',
                data
            };
        });

        if (this.lineChart) {
            this.lineChart.destroy();
        }

        this.lineChart = Highcharts.chart(`chart-line-${this.uniqueId}`, {
            chart: {
                type: 'line',
            },
            title: {
                text: this.dynamicChart.title,
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: true,
            },
            yAxis: {
                title: {
                    text: null,
                }
            },
            xAxis: {
                categories,
                title: {
                    text: this.xAxisColumns.map(x => x.name || x.columnNameId).join(' / '),
                },
            },
            tooltip: {
                shared: true,
                useHTML: true,
                headerFormat: `<div>{point.key}</div>`,
                pointFormat: `<div>{series.name}: {point.y}</div>`,
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    enableMouseTracking: true
                }
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                    }
                }
            },
            series
        } as any);
    }

    private generateGanttChart(): void {
        const tableFields = this.dynamicChart.columns.filter(x => x.isReference == 'namefield' && x.name !== this.selectedGroupBy?.name);
        const categories: string[] = this.dynamicChart.columns.find(x => x.name == this.selectedGroupBy?.name)?.dataList || [];
        const startColumn = this.dynamicChart.columns.find(x => x.isReference == 'startdate');
        const endColumn = this.dynamicChart.columns.find(x => x.isReference == 'enddate');
        const startDates: string[] = startColumn?.dataList || [];
        const endDates: string[] = endColumn?.dataList || [];

        // Ensure we have valid data to display
        if (!categories.length || !startDates.length || !endDates.length) {
            console.error('Missing required data for Gantt chart');
            return;
        }

        const series: any[] = [{
            name: this.selectedGroupBy?.name || 'Tasks',
            data: []
        }];

        // Find min and max dates for chart boundaries
        let minDate: Date | null = null;
        let maxDate: Date | null = null;

        // Process data ensuring valid dates
        categories.forEach((category: string, i) => {
            if (!startDates[i] || !endDates[i]) {
                console.warn(`Missing date data for item ${category}`);
                return; // Skip this item
            }

            // Parse dates properly
            const start = new Date(startDates[i]);
            const end = new Date(endDates[i]);

            // Skip invalid dates
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                console.warn(`Invalid date format for item ${category}`);
                return;
            }

            // Track min/max dates for chart boundaries
            if (!minDate || start < minDate) minDate = start;
            if (!maxDate || end > maxDate) maxDate = end;

            const tableValue = {};
            tableFields.map((tableField: any) => {
                tableValue[tableField.columnNameId] = tableField.dataList[i] || null;
            });

            // Add data point
            series[0].data.push({
                name: category || `Task ${i + 1}`,
                id: `task-${i}`,
                start: start.getTime(),
                end: end.getTime(),
                y: i,
                ...tableValue
            });
        });

        let columns = [];
        let pointFormat = "";

        columns.push({
            title: {
                text: this.selectedGroupBy?.name
            },
            categories: categories
        });

        tableFields.map((tableField: any) => {
            pointFormat += `<br/><span>${tableField.name}: {point.${tableField.columnNameId}}</span>`;
            columns.push({
                title: {
                    text: tableField?.name
                },
                categories: tableField.dataList||[]
            });
        });
        pointFormat += `<br/><span>${startColumn.name}: {point.start:%m-%d-%Y}</span>`;
        pointFormat += `<br/><span>${endColumn.name}: {point.end:%m-%d-%Y}</span>`;

        // If we have no valid data points, don't render
        if (!series[0].data.length) {
            console.error('No valid data points for Gantt chart');
            return;
        }

        if (this.ganttChart) {
            this.ganttChart.destroy();
        }


        this.ganttChart = HighchartsG.ganttChart(`chart-gantt-${this.uniqueId}`, {
            series: series,
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                        style: {
                            fontWeight: 'normal',
                            textOverflow: 'ellipsis'
                        }
                    }
                }
            },
            title: {
                text: this.dynamicChart.title
            },
            tooltip: {
                pointFormat: pointFormat
            },
            navigator: {
                enabled: true,
                liveRedraw: true,
                series: {
                    type: 'gantt',
                    pointPlacement: 0.5,
                    pointPadding: 0.25,
                    accessibility: {
                        enabled: false
                    }
                },
                yAxis: {
                    min: 0,
                    max: 3,
                    reversed: true,
                    categories: []
                }
            },
            scrollbar: {
                enabled: true
            },
            rangeSelector: {
                enabled: true,
                selected: 0
            },
            lang: {
                accessibility: {
                    axis: {
                        xAxisDescriptionPlural: 'The chart has a two-part X axis ' +
                            'showing time in both week numbers and days.',
                        yAxisDescriptionSingular: 'The chart has a tabular Y axis ' +
                            'showing a data table row for each point.'
                    }
                }
            },
            accessibility: {
                keyboardNavigation: {
                    seriesNavigation: {
                        mode: 'serialize'
                    }
                },
                point: {
                    valueDescriptionFormat: '{point.name} from ' +
                        '{point.x:%A, %B %e} to {point.x2:%A, %B %e}.'
                },
                series: {
                    descriptionFormat: '{series.name}, task {add series.index 1} of ' +
                        '{series.chart.series.length}.'
                }
            },
            xAxis: {
                currentDateIndicator: {
                    label: {
                        allowOverlap: true
                    }
                }
            },
    yAxis: {
        type: 'category',
        grid: {
            columns: columns
        }
    }
} as any);

        // this.ganttChart = HighchartsG.ganttChart(`chart-gantt-${this.uniqueId}`, {
        //     title: {
        //         text: this.dynamicChart.title
        //     },
        //     yAxis: {
        //         uniqueNames: true
        //     },
        //     tooltip: {
        //         pointFormat: '<span>Start: {point.start:%Y-%m-%d}</span><br/><span>End: {point.end:%Y-%m-%d}</span>'
        //     },
        //     navigator: {
        //         enabled: true,
        //         liveRedraw: true,
        //         series: {
        //             type: 'gantt',
        //             pointPlacement: 0.5,
        //             pointPadding: 0.25,
        //             accessibility: {
        //                 enabled: false
        //             }
        //         },
        //         yAxis: {
        //             min: 0,
        //             max: 3,
        //             reversed: true,
        //             categories: []
        //         }
        //     },
        //     scrollbar: {
        //         enabled: true
        //     },
        //     rangeSelector: {
        //         enabled: true,
        //         selected: 0
        //     },
        //     accessibility: {
        //         point: {
        //             descriptionFormat: "{yCategory}. Start {x:%Y-%m-%d}, end {x2:%Y-%m-%d}."
        //         },
        //         series: {
        //             descriptionFormat: "{name}"
        //         }
        //     },
        //     exporting: {
        //         enabled: true,
        //         buttons: {
        //             contextButton: {
        //                 menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
        //             }
        //         }
        //     },
        //     series: series
        // } as any);
    }

    //#endregion
}
